import React from "react";
import ReactDOM from "react-dom";

import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));

if (module.hot) {
  module.hot.accept("./App", () => {
    // If you use Webpack 2 in ES modules mode, you can
    // use <App /> here rather than require() a <NextApp />.
    const NextApp = require("./App").default;
    ReactDOM.render(
      <NextApp />,
      document.getElementById("root")
    );
  });
}



// WEBPACK FOOTER //
// ./src/example/index.js